import {SpriteButton} from '@fantasmagames/core/src/display/SpriteButton';

export class Checkbox {
	protected _onButton: SpriteButton;
	protected _offButton: SpriteButton;
	protected _changedCallback: Function;
	protected _isOn: boolean = false;

	constructor(onButton: SpriteButton, offButton: SpriteButton, changedCallback?: Function) {
		this._onButton = onButton;
		this._offButton = offButton;
		this._changedCallback = changedCallback;

		this._onButton.callback = this.onOnButtonClicked.bind(this);
		this._offButton.callback = this.onOffButtonClicked.bind(this);

		this.updateState();
	}

	protected onOnButtonClicked(): void {
		this._onButton.visible = false;
		this._offButton.visible = true;

		this._changedCallback && this._changedCallback(false);
	}

	protected onOffButtonClicked(): void {
		this._onButton.visible = true;
		this._offButton.visible = false;

		this._changedCallback && this._changedCallback(true);
	}

	public enable(): void {
		if (this.value) {
			this._onButton.enable();
		} else {
			this._offButton.enable();
		}
	}

	public disable(): void {
		if (this.value) {
			this._onButton.disable();
		} else {
			this._offButton.disable();
		}
	}

	public hide(): void {
		this._onButton.visible = false;
		this._offButton.visible = false;
	}

	public show(): void {
		this.updateState();
	}

	public set changedCallback(value: Function) {
		this._changedCallback = value;
	}

	public setValue(isOn: boolean, callCallback: boolean = false): void {
		this._isOn = isOn;

		this.updateState();

		callCallback && this._changedCallback && this._changedCallback(isOn);
	}

	protected updateState(): void {
		this._onButton.visible = this._isOn;
		this._offButton.visible = !this._isOn;
	}

	public get value(): boolean {
		return this._isOn;
	}

	public set value(isOn: boolean) {
		this.setValue(isOn, true);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/display/Checkbox.ts